exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._114lLG07XPxbRZ58dztA3h{font-size:14px}html[dir] ._114lLG07XPxbRZ58dztA3h{border-bottom:1px solid var(--neutralLight);margin-bottom:4px;margin-top:10px;padding-bottom:8px}html[dir=ltr] ._114lLG07XPxbRZ58dztA3h{margin-left:-12px;margin-right:-24px;padding-left:12px}html[dir=rtl] ._114lLG07XPxbRZ58dztA3h{margin-right:-12px;margin-left:-24px;padding-right:12px}", ""]);

// exports
exports.locals = {
	"spellerLabel": "_114lLG07XPxbRZ58dztA3h"
};